<template>
  <div style="overflow: hidden">
    <div class="body-wrapper-asset">
      <div ref="container">
      <van-pull-refresh
        class="refresh-box pullStyle"
        id="refresh-box"
        v-model="isLoading"
        @refresh="onRefresh"
        success-text="刷新成功"
        :head-height="58"
      >
        <div class="sub-refresh-box">
          <div class="serach_box_wrap before"></div>
          <div class="serach_box_wrap">
            <div class="search_box" @click.stop="navigationClick('1')">
              请输入产品名称/代码
            </div>
            <div class="icon_box" v-show="showWhiteIcon">
              <img
                :src="require('@/assets/images/icons/msg-2.png')"
                @click="navigationClick('2')"
                class="mesg"
                id="mesg"
              />
              <span class="mesg_after" v-if="countMsg > 0">{{ countMsg }}</span>
              <img
                :src="require('@/assets/images/icons/phone_icon_white.png')"
                @click="navigationClick('3')"
                class="phone_icon"
                id="phone_icon"
              />
            </div>
            <div class="icon_box" v-show="!showWhiteIcon">
              <img
                :src="require('@/assets/images/icons/msg_black.png')"
                @click="navigationClick('2')"
                class="mesg"
                id="mesg"
              />
              <span class="mesg_after" v-if="countMsg > 0">{{ countMsg }}</span>
              <img
                :src="require('@/assets/images/icons/phone_black2.png')"
                @click="navigationClick('3')"
                class="phone_icon"
                id="phone_icon"
              />
            </div>
          </div>
          <img class="banner" :src="bannerUrl" />
          <div class="blank-wrp">
            <!-- <div
            v-if="showNoticeBar && baseInfoFromNative.company == '5'"
            class="newsBar">
            <van-notice-bar
            left-icon="volume-o"
            class="modifyStyle"
            :text="infoCopywritingList[infoCopywritingNum].copywriting"  
            @replay="handleReplay()" 
            :delay="0"
            :scrollable="true">
            </van-notice-bar>
            </div> -->
            <div class="des" v-cloak>
              <div class="des-flex" @click="eyesClick">
                总资产(元)
                <van-icon
                  name="eye-o"
                  color="#FFF"
                  class="vanIconStyle"
                  v-if="eyeIsShow"
                />
                <van-icon
                  name="closed-eye"
                  color="#FFF"
                  class="vanIconStyle"
                  v-else
                />
              </div>
              <div class="des-flex right" @click="assetsExplain">
                资产说明
                <van-icon name="question-o" color="#FFF" class="vanIconStyle" />
              </div>
            </div>
            <div class="total">
              <span v-if="(eyeIsShow && !getDataScuccessed) || dataInterfaceError ">计算中</span>
              <span v-else-if="eyeIsShow && getDataScuccessed">{{
                assetsObj.totalAssets | formatMoney
              }}</span>
              <span v-else-if="!eyeIsShow && getDataScuccessed">****</span>
            </div>
            <!--中间显示区域-->
            <div class="jgq">
              <div class="item alignLeft paddingLeft">
                <span
                  v-color-if="assetsObj.totalIncome"
                  v-if="eyeIsShow && getDataScuccessed"
                  :style="{ fontSize: totalFontSize }"
                  >{{ assetsObj.totalIncome }}</span
                >
                <span
                  v-else-if="eyeIsShow && !getDataScuccessed"
                  :style="{ fontSize: totalFontSize }"
                  >--</span
                >
                <span v-else>****</span>
                <span class="bottom" v-if="exitsStockAndOther">总收益</span>
                <span class="bottom" v-else>累计收益</span>
              </div>
              <div class="item">
                <span
                  v-color-if="assetsObj.totalReturn"
                  v-if="eyeIsShow"
                  :style="{ fontSize: totalFontSize }"
                  >{{ assetsObj.totalReturn }}</span
                >
                <span v-else>****</span>
                <span class="bottom" v-if="exitsStockAndOther">实现收益</span>
                <span class="bottom" v-else>清仓收益</span>
              </div>
              <div class="item alignRight paddingRight">
                <span
                  v-if="eyeIsShow"
                  v-color-if="assetsObj.totalFloatingProfit"
                  :style="{ fontSize: totalFontSize }"
                  >{{ assetsObj.totalFloatingProfit }}</span
                >
                <span v-else>****</span>
                <span class="bottom">浮动盈亏</span>
              </div>
            </div>
            <van-notice-bar v-if="messageList && baseInfoFromNative.company == '5'" class="newsBar" color="#333"
            background="#fff" left-icon="volume-o" :text="messageList" scrollable/>
          </div>
         
          <div class="title">资产明细(元)</div>

          <!-- 公募模块 -->
          <div
            class="card-wrap"
            @click="assetsDetailClick('1')"
            v-if="baseInfoFromNative.company == '1'"
          >
            <span class="top"
              >公募基金
              <span class="top-right" v-if="eyeIsShow"
                >(存续规模：<span>{{
                  assetsObj.publicOfferingDto.totalAmount | formatMoney
                }}</span
                >)</span
              >
              <span class="top-right" v-else>(存续规模：****)</span>
            </span>
            <div
              class="wrap-item"
              :style="{
                marginTop:
                  assetsObj.publicOfferingDto.numberOfOrdersInTransit &&
                  assetsObj.publicOfferingDto.numberOfOrdersInTransit > 0
                    ? '0.32rem'
                    : '0.24rem',
              }"
            >
              <div class="item alignLeft">
                <span
                  v-color-if="assetsObj.publicOfferingDto.yesterdaySEarnings"
                  v-if="eyeIsShow"
                  >{{ assetsObj.publicOfferingDto.yesterdaySEarnings }}</span
                >
                <span v-else>****</span>
                <span class="bottom">昨日收益</span>
              </div>
              <div
                class="onway-order"
                v-if="
                  assetsObj.publicOfferingDto.numberOfOrdersInTransit &&
                  assetsObj.publicOfferingDto.numberOfOrdersInTransit > 0
                "
              >
                {{
                  assetsObj.publicOfferingDto.numberOfOrdersInTransit
                }}笔在途订单
              </div>
              <div class="item alignRight">
                <span
                  v-color-if="assetsObj.publicOfferingDto.positionIncome"
                  v-if="eyeIsShow"
                  >{{ assetsObj.publicOfferingDto.positionIncome }}</span
                >
                <span v-else>****</span>
                <span class="bottom">持有收益</span>
              </div>
            </div>
            <div class="divide"></div>
            <div class="wrap-item">
              <div class="item alignLeft">
                <span
                  v-color-if="assetsObj.publicOfferingDto.floatingProfitAndLoss"
                  v-if="eyeIsShow"
                  :style="{ fontSize: pubFontSize }"
                  >{{ assetsObj.publicOfferingDto.floatingProfitAndLoss }}</span
                >
                <span v-else>****</span>
                <span class="bottom">浮动盈亏</span>
              </div>
              <div class="item">
                <span
                  v-color-if="assetsObj.publicOfferingDto.realizedReturn"
                  v-if="eyeIsShow"
                  :style="{ fontSize: pubFontSize }"
                  >{{ assetsObj.publicOfferingDto.realizedReturn }}</span
                >
                <span v-else>****</span>
                <span class="bottom">清仓收益</span>
              </div>
              <div class="item alignRight">
                <span
                  v-color-if="assetsObj.publicOfferingDto.cumulativeIncome"
                  v-if="eyeIsShow"
                  :style="{ fontSize: pubFontSize }"
                  >{{ assetsObj.publicOfferingDto.cumulativeIncome }}</span
                >
                <span v-else>****</span>
                <span class="bottom">累计收益</span>
              </div>
            </div>
          </div>

          <!-- 私募证券模块 -->
          <div class="card-wrap extend" @click="assetsDetailClick('2')" :style="{paddingBottom:!showEntry?'0.16rem':'0'}">
            <span class="top"
              >私募证券
              <span class="top-right" v-if="eyeIsShow"
                >(存续规模：<span>{{
                  assetsObj.privateEquityDto.totalAmount | formatMoney
                }}</span
                >)</span
              >
              <span class="top-right" v-else>(存续规模：****)</span>
            </span>
            <div
              class="wrap-item"
              :style="{
                marginTop:
                  assetsObj.privateEquityDto.orderInTransit &&
                  assetsObj.privateEquityDto.orderInTransit > 0
                    ? '0.32rem'
                    : '0.24rem',
              }"
            >
              <div class="item alignLeft">
                <span
                  v-color-if="assetsObj.privateEquityDto.floatingProfit"
                  v-if="eyeIsShow"
                  :style="{ fontSize: priFontSize }"
                  >{{ assetsObj.privateEquityDto.floatingProfit }}</span
                >
                <span v-else>****</span>
                <span class="bottom">浮动盈亏</span>
              </div>
              <div class="item">
                <span
                  v-color-if="assetsObj.privateEquityDto.realizedReturn"
                  v-if="eyeIsShow"
                  :style="{ fontSize: priFontSize }"
                  >{{ assetsObj.privateEquityDto.realizedReturn }}</span
                >
                <span v-else>****</span>
                <span class="bottom">清仓收益</span>
              </div>
              <div
                class="onway-order"
                v-if="
                  assetsObj.privateEquityDto.orderInTransit &&
                  assetsObj.privateEquityDto.orderInTransit > 0
                "
              >
                {{ assetsObj.privateEquityDto.orderInTransit }}笔在途订单
              </div>
              <div class="item alignRight">
                <span
                  v-color-if="assetsObj.privateEquityDto.cumulativeIncome"
                  v-if="eyeIsShow"
                  :style="{ fontSize: priFontSize }"
                  >{{ assetsObj.privateEquityDto.cumulativeIncome }}</span
                >
                <span v-else>****</span>
                <span class="bottom">累计收益</span>
              </div>
            </div>
            <div class="investment_analysis_block" v-show="showEntry">
              <div class="block-left"><img  src="@assets/images/assets/icon20250509001.png"/></div>
              <div @click.stop="investmentAnalysisClick" class="block-right">
                <span>精准分析持仓，收益尽在掌握</span><img src="@assets/images/assets/right-yellow.png"/></div>
            </div>
          </div>

          <!-- 私募股权模块 -->
          <div
            class="card-wrap"
            @click="assetsDetailClick('3')"
            v-if="baseInfoFromNative.company == '1' && exitStock"
          >
            <span class="top"
              >私募股权
              <span class="top-right" v-if="eyeIsShow"
                >(实缴金额：<span>{{
                  assetsObj.equityDto.totalAmount | formatMoney
                }}</span
                >)</span
              >
              <span class="top-right" v-else>(实缴金额：****)</span>
            </span>
            <div
              class="wrap-item"
              :style="{
                marginTop:
                  assetsObj.equityDto.orderInTransit &&
                  assetsObj.equityDto.orderInTransit > 0
                    ? '0.32rem'
                    : '0.24rem',
              }"
            >
              <div class="item alignLeft">
                <span
                  v-color-if="assetsObj.equityDto.amountReturned"
                  v-if="eyeIsShow"
                  :style="{ fontSize: stockFontSize }"
                  >{{ assetsObj.equityDto.amountReturned }}</span
                >
                <span v-else>****</span>
                <span class="bottom">已回款金额</span>
              </div>
              <div class="item">
                <span
                  v-color-if="assetsObj.equityDto.realizedReturn"
                  v-if="eyeIsShow"
                  :style="{ fontSize: stockFontSize }"
                  >{{ assetsObj.equityDto.realizedReturn }}</span
                >
                <span v-else>****</span>
                <span class="bottom">已回款收益</span>
              </div>
              <div
                class="onway-order"
                v-if="
                  assetsObj.equityDto.orderInTransit &&
                  assetsObj.equityDto.orderInTransit > 0
                "
              >
                {{ assetsObj.equityDto.orderInTransit }}笔在途订单
              </div>
              <div class="item alignRight">
                <span
                  v-color="assetsObj.equityDto.investmentRecoveryRate"
                  v-if="eyeIsShow"
                  :style="{ fontSize: stockFontSize }"
                  >{{ assetsObj.equityDto.investmentRecoveryRate }}</span
                >
                <span v-else>****</span>
                <span class="bottom">投资回款率</span>
              </div>
            </div>
          </div>

          <!-- 其他模块 -->
          <div
            class="card-wrap"
            @click="assetsDetailClick('4')"
            v-if="baseInfoFromNative.company == '1' && exitOther"
          >
            <span class="top"
              >其他产品
              <span class="top-right" v-if="eyeIsShow"
                >(未回款金额：<span>{{
                  assetsObj.otherFundsDto.totalAmount | formatMoney
                }}</span
                >)</span
              >
              <span class="top-right" v-else>(未回款金额：****)</span>
            </span>
            <div
              class="wrap-item"
              :style="{
                marginTop:
                  assetsObj.otherFundsDto.orderInTransit &&
                  assetsObj.otherFundsDto.orderInTransit > 0
                    ? '0.32rem'
                    : '0.24rem',
              }"
            >
              <div class="item alignLeft">
                <span
                  v-color-if="assetsObj.otherFundsDto.amountReturned"
                  v-if="eyeIsShow"
                  :style="{ fontSize: otherFontSize }"
                  >{{ assetsObj.otherFundsDto.amountReturned }}</span
                >
                <span v-else>****</span>
                <span class="bottom">已回款金额</span>
              </div>
              <div class="item">
                <span
                  v-color-if="assetsObj.otherFundsDto.realizedReturn"
                  v-if="eyeIsShow"
                  :style="{ fontSize: otherFontSize }"
                  >{{ assetsObj.otherFundsDto.realizedReturn }}</span
                >
                <span v-else>****</span>
                <span class="bottom">已回款收益</span>
              </div>
              <div
                class="onway-order"
                v-if="
                  assetsObj.otherFundsDto.orderInTransit &&
                  assetsObj.otherFundsDto.orderInTransit > 0
                "
              >
                {{ assetsObj.otherFundsDto.orderInTransit }}笔在途订单
              </div>
              <div class="item alignRight">
                <span
                  v-color="assetsObj.otherFundsDto.investmentRecoveryRate"
                  v-if="eyeIsShow"
                  :style="{ fontSize: otherFontSize }"
                  >{{ assetsObj.otherFundsDto.investmentRecoveryRate }}</span
                >
                <span v-else>****</span>
                <span class="bottom">投资回款率</span>
              </div>
            </div>
          </div>

          <!--金刚区-->
          <div class="menu-wrap">
            <div
              v-for="item in menuList"
              :key="item.value"
              class="icon-item"
              @click="menuClick(item.name, item.link, item.source)"
            >
              <img :src="item.photoUrl" />
              <span>{{ item.name }}</span>
              <span
                :class="{ todo: item.name == '我的待办' }"
                v-if="item.name == '我的待办' && remindCount > 0"
                >{{ remindCount }}</span
              >
            </div>
          </div>
          <div class="flex-wrap">
            <div class="savePhoto left" :class="{ 'redBg': !isInvestmentReportShow }" @click="saveScreenShot" v-if="!shotLoading">一键保存长图</div>
            <div class="savePhoto" v-if="isInvestmentReportShow" @click="queryAssetReport">查看资产报告</div>
          </div>
          <template v-if="baseInfoFromNative.company == '1'">
            <p class="bottom-tip top24">
              声明：本页面产品信息及持仓数据仅供投资者参考，请投资者以基金管理人及份额登记机构、基金托管人或估值核算机构发布的具体数据为准。如有疑问，请及时联系客服。
            </p>
            <p class="bottom-tip top16">市场有风险，投资需谨慎</p>
            <p class="bottom-tip">基金销售服务由上海陆享基金销售有限公司提供</p>
          </template>
          <!-- 兼容杭州陆享下拉刷新会被盖住一点 -->
          <template v-else>
            <div class="prop-wrap"></div>
          </template>
        </div>
      </van-pull-refresh>
      </div>
    </div>
    <template v-if="baseInfoFromNative.company == '1'">
      <tips
      v-if="exitsStockAndOther"
      :content="tipsContentByAll"
      @closeTips="closeTipChange"
      ref="tipComponent"
    ></tips>
    <tips
      v-else
      :content="tipsContent"
      @closeTips="closeTipChange"
      ref="tipComponent"
    ></tips>
    </template>
  <template v-else>
    <tips
      :content="tipsContentByhzlx"
      @closeTips="closeTipChange"
      ref="tipComponent"
    ></tips>
  </template>
  <div class="assets-loading" v-if="shotLoading">
      <div class="wrapperL">
        <van-loading size="36px" type="spinner" color="#fff" text-color="#fff" vertical class="loadingS">截图中</van-loading>
      </div>
  </div>
  </div>
</template>
<script>
import axios from "axios";
import requestApi from "@/config/assetAnalysisApi";

import { mapState } from "vuex";
import { PullRefresh } from "vant";

import _ from "lodash";
import tips from "../tips.vue";
import html2canvas from 'html2canvas'
export default {
  name: "index",
  components: {
    tips,
    [PullRefresh.name]: PullRefresh,
    html2canvas
  },
  computed: {
    ...mapState([
      "baseInfoFromNative",
      "personalAccount",
      "setHeader",
      "getHeadInfo",
      "scrollPositions",
      "deviceInfo",
    ]),
    totalFontSize() {
        const dataLength = Math.max(String(this.assetsObj.totalFloatingProfit ?? '').length, String(this.assetsObj.totalReturn ?? '').length, String(this.assetsObj.totalIncome ?? '').length);
        if (dataLength > 11) { // 数据长度到亿,包含小数点后两位
          return '0.13rem';
        } else if (dataLength > 10) { // 数据长度到千万
          return '0.14rem';
        } else if (dataLength > 9) { // 数据长度到百万
          return '0.15rem';
        } else { // 数据长度到百万及以下
          return '0.16rem';
        }
    },
    pubFontSize() {
        const dataLength = Math.max(String(this.assetsObj.publicOfferingDto.floatingProfitAndLoss ?? '').length, String(this.assetsObj.publicOfferingDto.realizedReturn ?? '').length, String(this.assetsObj.publicOfferingDto.cumulativeIncome ?? '').length);
        if (dataLength > 11) { // 数据长度到亿
          return '0.13rem';
        } else if (dataLength > 10) { // 数据长度到千万
          return '0.14rem';
        } else if (dataLength > 9) { // 数据长度到百万
          return '0.15rem';
        }  else  { // 数据长度到百万以下
          return '0.16rem';
        }
    },
    priFontSize() {
        const dataLength = Math.max(String(this.assetsObj.privateEquityDto.floatingProfit ?? '').length, String(this.assetsObj.privateEquityDto.realizedReturn ?? '').length, String(this.assetsObj.privateEquityDto.cumulativeIncome ?? '').length);
        if (dataLength > 11) { // 数据长度到亿
          return '0.13rem';
        } else if (dataLength > 10) { // 数据长度到千万
          return '0.14rem';
        } else if (dataLength > 9) { // 数据长度到百万
          return '0.15rem';
        }  else  { // 数据长度到百万以下
          return '0.16rem';
        }
    },
    stockFontSize() {
        const dataLength = Math.max(String(this.assetsObj.equityDto.amountReturned ?? '').length, String(this.assetsObj.equityDto.realizedReturn ?? '').length);
        if (dataLength > 11) { // 数据长度到亿
          return '0.13rem';
        } else if (dataLength > 10) { // 数据长度到千万
          return '0.14rem';
        } else if (dataLength > 9) { // 数据长度到百万
          return '0.15rem';
        }  else  { // 数据长度到百万以下
          return '0.16rem';
        }
    },
    otherFontSize() {
        const dataLength = Math.max(String(this.assetsObj.otherFundsDto.amountReturned ?? '').length, String(this.assetsObj.otherFundsDto.realizedReturn ?? '').length);
        if (dataLength > 11) { // 数据长度到亿
          return '0.13rem';
        } else if (dataLength > 10) { // 数据长度到千万
          return '0.14rem';
        } else if (dataLength > 9) { // 数据长度到百万
          return '0.15rem';
        }  else  { // 数据长度到百万以下
          return '0.16rem';
        }
    }
  },
  watch: {
    "baseInfoFromNative.groupCommonId": {
      handler(newVal, oldVal) {
        if (newVal) {
          if (this.isOnceExeue) {
            return;
          }
          sessionStorage.removeItem('isInvestmentReportShow');
          sessionStorage.removeItem('showEntry');
          this.getData();
          console.log("++++执行了watch");
          this.isOnceExeue = true;
        }
      },
    },
    dataInterfaceError: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$dialog.alert({
            message: `资产计算中，请您稍后再试`,
            confirmButtonText: "确认",
            confirmButtonColor: "#E12817",
          })
          .then(() => {
            this.getDataScuccessed = false
            this.$nextTick(()=>{
              this.dataInterfaceError = false
            })
            // this.assetsObj.totalAssets = "计算中"
            if (this.IOS.ios()) {
              window.webkit.messageHandlers.toRootVC.postMessage("");
            } else {
              window.android.jumpMainPageHome();
            }
          });
        }
      },
    },
  },
  data() {
    return {
      showEntry:false,
      showEntry:sessionStorage.getItem('showEntry') || false, //是否显示分析入口,
      dataInterfaceError: false,//如果心跳接口返回异常，就弹框
      getDataScuccessed:false,
      bannerUrl: require("@/assets/images/header/private-list-bg.png"), //背景图片
      isLoading: false,
      img: require("@/assets/images/publicFundsChange/search-black.png"), //搜索黑色图片
      showWhiteIcon: true, //显示导航栏白色图标
      customerServicePhone: "",
      scrollPosition: {},
      countMsg: 0, //消息数量
      remindCount: 0, //待办数量
      eyeIsShow: false, //眼睛状态是否显示资产
      isOnceExeue: false, //接口是否执行
      assetsObj: {
        totalAssets: "",
        totalFloatingProfit:'',
        totalReturn:'',
        totalIncome:'',
        publicOfferingDto: {
          floatingProfitAndLoss: '',
          realizedReturn: '',
          cumulativeIncome: ''
        },
        privateEquityDto: {
          floatingProfit: '',
          realizedReturn: '',
          cumulativeIncome: ''
        },
        equityDto: {
          amountReturned: '',
          realizedReturn: ''
        },
        otherFundsDto: {
          amountReturned: '',
          realizedReturn: ''
        },
      }, //资产接口返回的数据
      exitsStockAndOther: false, //是否包含股权和其他
      exitStock: false, //是否包含股权
      exitOther: false, //是否包含其他产品
      menuList: [
        {
          photoUrl: require("@/assets/images/icons/todo.png"),
          name: "我的待办",
          link: "",
          source: "2",
          isNeedLogin: true,
        },
        {
          photoUrl: require("@/assets/images/icons/jy_icon.png"),
          name: "我的交易",
          link: "",
          source: "3",
          isNeedLogin: true,
        },
        {
          photoUrl: require("@/assets/images/assets/disclosure.png"),
          name: "我的信披",
          link: "/disclosureNative",
          source: "",
          isNeedLogin: true,
        },
        {
          photoUrl: require("@/assets/images/icons/zixuan.png"),
          name: "我的自选",
          link: "/myChoice",
          source: "",
          isNeedLogin: true,
        },
      ],
      tipsContentByhzlx: [
        {
          title: "私募证券存续规模",
          text: [
            "包含私募证券持有金额和买入待确认金额。",
            "持有金额=持有份额*最新单位净值",
            "买入待确认金额：签约及双录已完成、资金状态全额到账、基金公司未确认的订单金额"
          ],
        },
        {
          title: "浮动盈亏",
          text: [
            "当前持仓基金的全部申购份额产生的收益，包含部分赎回份额的收益和现金分红，不包含历史已全部清仓基金的收益",
            "浮动盈亏=持有金额+赎回金额+现金分红-投资金额",
            "浮动盈亏收益率=浮动盈亏/投资金额",
          ],
        },
        {
          title: "清仓收益",
          text: [
            "当前已全部清仓基金产生的收益，包含全部赎回份额的收益和现金分红",
            "清仓收益=全部赎回金额+现金分红-投资金额",
            "清仓收益率=清仓收益/投资金额",
          ],
        },
        {
          title: "累计收益",
          text: [
            "私募证券产品的收益之和，包含当前持仓产品的浮动盈亏，和已清仓产品的清仓收益",
          ],
        },
      ],
      tipsContentByAll: [
        {
          title: "总资产",
          text: [
            "您在陆享基金平台所持仓产品的资产量总和（含买入待确认金额）",
            "总资产=公募基金存续规模+私募证券存续规模+其余产品的实缴金额或未回款金额（如有）",
          ],
        },
        {
          title: "总收益",
          text: [
            "您在陆享基金平台自认购以来的全部收益之和。总收益包含浮动盈亏和实现收益",
          ],
        },
        {
          title: "浮动盈亏",
          text: [
            "您当前持仓基金的全部申购份额产生的收益，包含部分赎回份额的收益和现金分红，不包含历史已全部清仓基金的收益",
            "浮动盈亏总和=公募基金浮动盈亏+私募证券浮动盈亏",
          ],
        },
        {
          title: "实现收益",
          text: [
            "您已全部清仓基金的收益，以及部分产品的已回款收益（如有）",
            "实现收益总和=公募基金清仓收益+私募证券清仓收益+其余产品的已回款收益（如有）",
          ],
        },
      ],
      tipsContent: [
        {
          title: "总资产",
          text: [
            "您在陆享基金平台所持仓产品的存续规模总和（含买入待确认金额）",
            "总资产=公募基金存续规模+私募证券存续规模",
          ],
        },
        {
          title: "累计收益",
          text: [
            "您在陆享基金平台自认购以来的全部收益之和，累计收益包含浮动盈亏和清仓收益",
          ],
        },
        {
          title: "浮动盈亏",
          text: [
            "您当前持仓基金的全部申购份额产生的收益，包含部分赎回份额的收益和现金分红，不包含历史已全部清仓基金的收益",
            "浮动盈亏总和=公募基金浮动盈亏+私募证券浮动盈亏",
          ],
        },
        {
          title: "清仓收益",
          text: [
            "您已全部清仓基金的收益。",
            "清仓收益总和=公募基金清仓收益+私募证券清仓收益",
          ],
        },
      ],
      messageList:'',
      shotLoading: false, //截图添加loading
      customerEmail: '', //用户邮箱
      isInvestmentReportShow: sessionStorage.getItem('isInvestmentReportShow') || false, //是否显示投资分析报告
    };
  },
  // 在离开首页时触发的操作
  beforeRouteLeave(to, from, next) {
    this.$store.commit("saveScrollPosition", {
      homeIndex: { position: this.scrollPosition },
    });
    this.isOnceExeue = false;
    next();
  },
  created() {
    if (this.baseInfoFromNative.groupCommonId) {
      if (this.isOnceExeue) {
        return;
      }
      console.log("++++执行了create");
      this.getData();
      this.isOnceExeue = true;
      this.pageInit
    }
  },
  mounted() {
    //原生登陆成功的回调
    let _this = this;
    dsBridge.registerAsyn(
      "updateLoginInfo",
      (responseData, responseCallback) => {
        if (!_this.IOS.ios()) {
          _this.$store.dispatch(
            "setBaseInfoFromNatvie",
            JSON.parse(responseData)
          );
        } else {
          _this.$store.dispatch("setBaseInfoFromNatvie", responseData);
        }
      }
    );
    //同级切换更新接口,锚点也要去掉
    dsBridge.registerAsyn("updateDataBytabChanged", (responseData, responseCallback) => {
      _this.clearPositionStore();
      _this.getData();
    });
    dsBridge.registerAsyn("infoByBack", (responseData, responseCallback) => {
      let json = responseData
      if (json) {
        if (!_this.IOS.ios()) {
          json = JSON.parse(json);
        }
        if (json.needRefreshByBack) {
          console.log("返回需要更新接口");
          _this.getData();
        }
      }
    });
    dsBridge.registerAsyn("getJsonData", (responseData, responseCallback) => {
      console.log("获取原生拿到的状态:", responseData, responseCallback);
      responseCallback({});
    });
    dsBridge.call("getLocalStorageJson", {}, function (responseData) {
      let json = responseData
      if (!_this.IOS.ios()) {
        json = JSON.parse(json);
      }
      console.log("首页进来getLocalStorageJson+++++++:", json);
      _this.eyeIsShow = json.eyeState == "1" ? true : false;
      _this.$store.state.eyeStatus = _this.eyeIsShow ? "open" : "close";
    });
    this.getPosition();

   
  },
  methods: {
    //获取是否显示分析入口
    showEntryMethod() {
      let params = {
        companyCommonId: this.baseInfoFromNative.orgCommonId,
      };
      if(this.baseInfoFromNative.orgCommonId){
        params.orgCommonId = this.baseInfoFromNative.orgCommonId
      }else{
        console.log('没有组织id');
        this.showEntry =false;
        return;
      } 
      this.$post(requestApi.analysisEntry, params, { loadingRequest: false }).then(
        (res) => {
          if (res.code === 10000) {
            this.showEntry = res.data.showFlag;
            if (this.showEntry) {
              sessionStorage.setItem('showEntry',true);
            }
          }
        }
      );
    },
    //投资分析
    investmentAnalysisClick() {
      let obj = {
        ...this.baseInfoFromNative,
        eye_open: this.eyeIsShow,
        ip: this.baseInfoFromNative.deviceNowIp,
        deviceId: this.baseInfoFromNative.deviceId,
        clientType: this.baseInfoFromNative.company,
        customType: this.baseInfoFromNative.userType,
        token: this.baseInfoFromNative.Authorization,
        companyId: this.baseInfoFromNative.company,
      };
      this.$store.commit("getPersonalAccount", obj);
      this.$store.dispatch("getSetHeader", { ...this.baseInfoFromNative });
      this.jumpToRoute("/investmentAnalysis");
    },
  
    //保存长图
    saveScreenShot() {
      this.shotLoading = true;
      document.querySelector(".body-wrapper-asset").scrollTop = 0;
      this.$nextTick(() => { 
        this.$forceUpdate() 
        let canvasID = this.$refs['container'];
        let that = this;
        let a = document.createElement('a');
        html2canvas(canvasID).then(canvas => {
            let dom = document.body.appendChild(canvas);
            dom.style.background = 'none';
            dom.style.display = 'none';
            a.style.display = 'none';
            document.body.removeChild(dom);
            let blob = that.dataURLToBlob(dom.toDataURL('image/png'));
            a.setAttribute('href', URL.createObjectURL(blob));
            //这块是保存图片操作  可以设置保存的图片的信息
            a.setAttribute('download', 212 + '.png');
            that.imageUrlToBase64(a.href)
        });
      })  
    },
    imageUrlToBase64(imageUrl) {
      let image = new Image();
      //解决跨域问题
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = imageUrl
      //image.onload为异步加载
      image.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        //这里的dataurl就是base64类型
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        var dataURL = canvas.toDataURL("image/jpeg", 1);//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！		
        let params = {
            requestType: "save_screen_shot",
            requestData: {
              imgUrl: dataURL
            }
        };
        this.shotLoading = false;
        if (this.IOS.ios()) {
            window.webkit.messageHandlers.requestEventData.postMessage(params); 
        } else {
            window.android.requestEventData(JSON.stringify(params));
        }
      }
    },
    dataURLToBlob (dataurl) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    handleReplay (){
      this.infoCopywritingNum = this.infoCopywritingNum+1
      if(this.infoCopywritingNum > this.infoCopywritingList.length-1){
        this.infoCopywritingNum = 0
      }
    },
    onRefresh() {
      this.clearPositionStore();
      document.querySelector(".sub-refresh-box").style.marginTop = "38px";
      setTimeout(() => {
        this.isLoading = false;
        this.getData();
        setTimeout(() => {
          document.querySelector(".sub-refresh-box").style.marginTop = "0px";
        }, 200);
      }, 1000);
    },
    //清空锚点缓存
    clearPositionStore() {
      this.$store.commit("saveScrollPosition", {});
      document.querySelector(".body-wrapper-asset").scrollTop = 0;
    },
    scrollHanler() {
      const bodyWrapper = document.querySelector(".body-wrapper-asset");
      this.scrollPosition = bodyWrapper.scrollTop;

      const pseudoElement = document.querySelector(".serach_box_wrap.before");
      if (this.scrollPosition > 0) {
        this.showWhiteIcon = false;
        document.querySelector(".serach_box_wrap>.search_box").style.border =
          "1px solid #999";
        pseudoElement.style.opacity = this.scrollPosition / 150;
      } else {
        this.showWhiteIcon = true;
        document.querySelector(".serach_box_wrap>.search_box").style.border =
          "1px solid #FFF";
        pseudoElement.style.opacity = this.scrollPosition;
      }
    },
    async getData() {
      try {
        await this.watchHeartBeat();
        if(this.dataInterfaceError){
          return false;
        };
      } catch (error) {
        console.error('Heartbeat check failed:', error);
        return false;
      }
      
      let params = {
        orgCommonId: this.baseInfoFromNative.orgCommonId,
        groupCommonId: this.baseInfoFromNative.groupCommonId,
      };
      let _this = this;
      this.$post(this.$api.assetHome, params, { loadingRequest: false }).then(
        (res) => {
          console.log("+++++资产首页返回的数据:", res);
          if (res.code === 10000) {
            var resVo = res.data;
            if (resVo.equityDto || resVo.otherFundsDto) {
              _this.exitsStockAndOther = true;
            } else {
              _this.exitsStockAndOther = false;
            }
            _this.exitStock = resVo.equityDto ? true : false;
            _this.exitOther = resVo.otherFundsDto ? true : false;
            _this.assetsObj.totalAssets = resVo.totalAssets; //总资产
            _this.assetsObj.totalFloatingProfit = resVo.totalFloatingProfit;
            _this.assetsObj.totalReturn = resVo.totalReturn;
            _this.assetsObj.totalIncome = resVo.totalIncome;
            _this.assetsObj.publicOfferingDto = resVo.publicOfferingDto || {};
            _this.assetsObj.privateEquityDto = resVo.privateEquityDto || {};
            _this.assetsObj.equityDto = resVo.equityDto || {};
            _this.assetsObj.otherFundsDto = resVo.otherFundsDto || {};
            _this.getPosition();
            if (this.baseInfoFromNative.company == '5') {
              this.showEntry = false;
            } else if(Number(_this.assetsObj.privateEquityDto.totalAmount)>0){
              this.showEntry = true;
              this.isInvestmentReportShow = true;
              sessionStorage.setItem('showEntry',true);
            }else{
              console.log('没有私募基金存续');
              this.showEntryMethod();
              this.reportShow();
            }
          } 
          else {
            _this.$toast(res.message);
          }
          _this.getDataScuccessed = true;
        }
      ).finally(() => {
        _this.isLoading = false;
      });
      this.getExtra();
      this.getCustomerEmail();
    },
    
    //获取用户邮箱
    getCustomerEmail() {
      //杭州陆享不请求接口
      if (this.baseInfoFromNative.company == '5') {
        return
      }
      if (!this.baseInfoFromNative.orgCommonId) {
        return
      }
      let params = {
        companyCommonId: this.baseInfoFromNative.orgCommonId,
      };
      this.$post(this.$api.analysisGetCustomerEmail, params, { loadingRequest: false }).then(
        (res) => {
          console.log("+++++获取用户邮箱:", res);
          this.customerEmail = res.data.email;
        }
      );
    },
    //投资分析报告是否显示
    reportShow() {
      if (!this.baseInfoFromNative.orgCommonId) {
        this.isInvestmentReportShow = false;
        return
      }
      let params = {
        companyCommonId: this.baseInfoFromNative.orgCommonId,
      };
      this.$post(this.$api.investmentReportShow, params, { loadingRequest: false }).then(
        (res) => {
          this.isInvestmentReportShow = res.data.showFlag;
          console.log("+++++投资分析报告是否显示:", res);
        }
      );
    },

    //请求额外接口
    getExtra() {
      let params = {
        orgCommonId: this.baseInfoFromNative.orgCommonId,
        groupCommonId: this.baseInfoFromNative.groupCommonId,
      };
      let _this = this;
      this.$post(this.$api.assetsExtra, params, { loadingRequest: false }).then(
        (res) => {
          console.log("+++++资产首页额外返回的数据:", res);
          if (res.code === 10000) {
            let resData = res.data;
            _this.remindCount = resData.count;
            _this.countMsg = resData.countMsg;
            _this.customerServicePhone = resData.customerServicePhone;
            if (resData.hasOwnProperty('appScrollMessageResList') && resData['appScrollMessageResList']?.length) {
            let messageListArr= [];
            resData['appScrollMessageResList'].map((ele)=>{
                    messageListArr.push(ele.copywriting)
                })
                this.messageList = messageListArr.join('')
            }else{
                this.messageList = '';
            }
          } 
          else {
            _this.$toast(res.message);
          }
        }
      );
    },
    //获取锚点定位
    getPosition() {
      document
      .querySelector(".body-wrapper-asset")
      .addEventListener("scroll", this.scrollHanler);
      if (
        this.scrollPositions &&
        this.scrollPositions.hasOwnProperty("homeIndex")
      ) {
        const { position } = this.scrollPositions["homeIndex"];
        if (position) {
          this.$nextTick(() => {
            document.querySelector(".body-wrapper-asset").scrollTop = position;
          });
        }
      }
    },
    //眼睛点击事件
    eyesClick() {
      this.eyeIsShow = !this.eyeIsShow;
      this.$store.commit("toggleEyeStatus");
    },
    //资产说明点击事件
    assetsExplain() {
      this.$refs.tipComponent.showTips = true;
      dsBridge.call("responseRequest", { requestType: "hiddenHomeTabbar" });
    },
    closeTipChange() {
      dsBridge.call("responseRequest", { requestType: "showHomeTabbar" });
    },
    //导航栏跳转
    navigationClick(index) {
      let json = {
        value: index,
        phone: this.customerServicePhone,
        needRefreshByBack: index == "2" ? true : false,
      };
      if (!this.IOS.ios()) {
        json = JSON.stringify(json);
      }
      dsBridge.call(
        "responseRequest",
        { requestType: "homeNavigation", data: json },
        function (responseData) {
          console.log("responseData:", responseData);
        }
      );
    },
    //资产明细点击跳转
    assetsDetailClick(index) {
      if(!this.getDataScuccessed || !this.assetsObj.privateEquityDto.totalAmount) return;
      var routePath = "/publicSurvival";
      if (index == "2" || index == "3" || index == "4") {
        routePath = "/privateSurvival";
      }
      var privateType = "";
      if (index == "2") {
        privateType = "1";
      } else if (index == "3") {
        privateType = "5";
      } else if (index == "4") {
        privateType = "4";
      }
      let obj = {
        ...this.baseInfoFromNative,
        eye_open: this.eyeIsShow,
        ip: this.baseInfoFromNative.deviceNowIp,
        deviceId: this.baseInfoFromNative.deviceId,
        clientType: this.baseInfoFromNative.company,
        privateType: privateType,
        customType: this.baseInfoFromNative.userType,
        token: this.baseInfoFromNative.Authorization,
        companyId: this.baseInfoFromNative.company,
      };
      this.$store.commit("getPersonalAccount", obj);
      this.$store.dispatch("getSetHeader", { ...this.baseInfoFromNative });
      this.jumpToRoute(routePath, { pageType: "H5", pageForm: "/assets" });
    },
    //菜单跳转
    menuClick(name, link, source) {
      this.$store.commit("setHomeFromPage", true);
      if (name == "我的自选") {
        if (this.baseInfoFromNative.company == "1") {
          this.jumpToRoute(link, { pageType: "H5", pageForm: "/assets" });
          return;
        }
        if (this.baseInfoFromNative.company == "5") {
          dsBridge.call(
            "responseRequest",
            { requestType: "jumpToMyChoice", data: {} },
            function (responseData) {
              console.log("responseData:", responseData);
            }
          );
          return;
        }

        return;
      }
      if (name == "我的信披") {
        let obj = {
          ...this.baseInfoFromNative,
        };
        this.$store.commit("getPersonalAccount", obj);
        this.jumpToRoute(link, { pageType: "H5", pageForm: "/assets" });
        return;
      }
      if (name == "我的待办" || name == "我的交易") {
        let json = {
          source: source,
          link: link,
          isNeedLogin: true,
          needRefreshByBack: name == "我的待办" ? true : false,
        };
        if (!this.IOS.ios()) {
          json = JSON.stringify(json);
        }
        dsBridge.call(
          "responseRequest",
          { requestType: "homeMenu", data: json },
          function (responseData) {
            console.log("responseData:", responseData);
          }
        );
      }
    },
    jumpToRoute(path, params) {
      this.$router.push({
        path: path,
        query: params,
      });
    },
    watchHeartBeat() {
      return new Promise((resolve, reject) => {
        this.$post(this.$api.heartbeat, {}, { loadingRequest: false })
          .then((res) => {
            if (res.code !== 20000) {
              this.dataInterfaceError = true;
              reject(new Error('Heartbeat interface returned an error'));
            } else {
              this.dataInterfaceError = false;
              resolve(res);
            }
          })
          .catch((err) => {
            this.dataInterfaceError = true;
            reject(err);
          });
      });
    },
    //查看资产报告
    queryAssetReport() {
      sessionStorage.setItem('isInvestmentReportShow',true);
      this.$router.push({
        path: "/pdfPreview",
        query: { queryInfo: {customerEmail: this.customerEmail} },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/style/mixin.scss";
[v-cloak] {
    display: none;
}
.blank-wrp {
  flex-wrap: wrap;
  padding: 0.1rem 0;
  margin-top: 0.8rem;
  position: relative;
  z-index: 90;
  color: #ffffff;
  .des {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.15rem;
    .des-flex {
      display: flex;
      align-items: center;
    }
    .right {
      font-size: 0.13rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
    }
    .vanIconStyle {
      padding-left: 0.08rem;
      font-size: 0.16rem;
    }
  }
  .total {
    margin-top: 0.08rem;
    font-size: 0.3rem;
  }
  .jgq {
    margin-top: 0.24rem;
    width: 3.43rem;
    height: 0.89rem;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    .item {
      /* 每个 item 占据一半宽度，减去间距 */
      @include flex($d: column);
      color: #333333;
      font-size: 0.16rem;
      width: 1.033rem;
      position: relative;
      justify-content: space-between;
      line-height: 0.21rem;

      .bottom {
        padding-top: 0.02rem;
        line-height: 0.2rem;
        font-size: 0.14rem;
        color: #999999;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
      }
    }
  }
}

.body-wrapper-asset {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: #f5f5f5;
  box-sizing: border-box;
  z-index: 1;
  overflow: auto;

  .sub-refresh-box {
    padding: 0.16rem;
  }

  /* 隐藏滚动条 */
  ::-webkit-scrollbar {
    display: none;
  }

  .serach_box_wrap {
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    padding-left: 0.16rem;
    padding-right: 0.16rem;
    padding-top: 0.51rem;
    padding-bottom: 0.07rem;
    z-index: 929;
    background: transparent;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;

    .search_box {
      width: 2.71rem;
      height: 0.3rem;
      font-family: PingFangSC, PingFang SC;
      background: #ffffff;
      border-radius: 0.15rem;
      border: 1px solid #fff;
      color: #999999;
      font-size: 0.13rem;
      display: flex;
      align-items: center;
      text-indent: 38px;
      position: relative;
      z-index: 999;
      box-sizing: border-box;

      &::after {
        display: inline-block;
        content: "";
        width: 0.16rem;
        height: 0.16rem;
        position: absolute;
        top: 0.07rem;
        left: 0.16rem;
        background-image: url("~@assets/images/publicFundsChange/search-icon.png");
        background-size: 100%;
      }
    }

    .icon_box {
      display: flex;
      position: relative;

      img {
        width: 0.2rem;
        height: 0.2rem;
      }

      img.phone_icon {
        margin-left: 0.16rem;
      }

      .mesg {
        position: relative;

        &_after {
          position: absolute;
          color: #ffffff;
          z-index: 10001;
          top: -0.1rem;
          left: 0.15rem;
          font-size: 0.1rem;
          width: 0.12rem;
          text-align: center;
          width: 0.2rem;
          background: #ef4034;
          border-radius: 0.08rem;
          border: 1.3px solid #ffffff;
          box-sizing: border-box;
        }
      }
    }
  }

  .serach_box_wrap.before {
    content: "";
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    height: 0.88rem;
    z-index: 919;
    background: #fff;
    opacity: 0;
  }

  .banner {
    width: 3.75rem;
    height: 2.4rem;
    background-color: #ca2415;
    background-size: 100% auto;
    background-position: top;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
  }
  .title {
    font-size: 0.15rem;
    text-align: left;
    padding-top: 0.06rem;
    padding-bottom: 0.09rem;
    line-height: 21px;
    color: #333333;
  }
  .card-wrap {
    border-radius: 0.08rem;
    background: #ffffff;
    font-size: 15px;
    padding: 0.16rem;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.16rem;
    .top {
      text-align: left;
      .top-right {
        padding-left: 0.08rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
      }
    }
    .wrap-item {
      display: flex;
      justify-content: space-between;
      font-size: 0.15rem;
      position: relative;
      .item {
        @include flex($d: column);
        line-height: 0.21rem;
        width: 1.0333rem;
        .bottom {
          padding-top: 0.02rem;
          color: #999999;
          font-size: 0.14rem;
          line-height: 0.2rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
        }
      }
    }
    .onway-order {
      position: relative;
      height: 0.16rem;
      padding-left: 0.08rem;
      padding-right: 0.08rem;
      position: absolute;
      top: -0.26rem;
      right: -0.16rem;
      height: 0.16rem;
      line-height: 0.16rem;
      color: #ffffff;
      font-size: 0.1rem;
      font-weight: 400;
      font-family: PingFangSC, PingFang SC;
      background-image: url("../../../assets/images/assets/asset-onOrder.png");
      background-size: 100%;
    }
    .divide {
      margin-top: 0.16rem;
      margin-bottom: 0.16rem;
      height: 1px;
      width: 100%;
      background-color: #eeeeee;
    }
    .investment_analysis_block {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 0.16rem;
      // border-top: 1px solid #eeeeee;
      padding-right: 0.16rem;
      background: linear-gradient( 270deg, #FFEFD8 0%, #FFECD0 63%, #FFFFFF 100%);
      border-radius: 8px 0px 8px 8px;
      margin-right: -0.16rem;
      height: 0.37rem;
      position: relative;
      .block-left{
        position: absolute;
        left:-0.16rem;
        bottom: 0;
        img {
          width: 1.22rem;
          height: 0.37rem;
          position: absolute;
          bottom: 0;
        }
      }
      span{
        text-align: right;
        font-family: PingFangSC, PingFang SC;
        font-size: 0.12rem;
        color: #CF7E0E;
        line-height: 0.17rem;
      }
      .block-right{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 0.37rem;
        span+img{
        width: 0.07rem;
        height: 0.1rem;
        margin-left: 0.04rem;
        }
      }
     
    }
  }
  .card-wrap.extend{
    padding-bottom: 0px;
  }
  .topFontSize13 {
    font-size: 0.13rem;
  }
  .fontSize14 {
    font-size: 0.14rem;
  }
  .alignLeft {
    align-items: flex-start !important;
  }
  .alignRight {
    align-items: flex-end !important;
  }
  .paddingLeft {
    padding-left: 0.16rem;
  }
  .paddingRight {
    padding-right: 0.16rem;
  }
  .menu-wrap {
    width: 3.43rem;
    height: 1.06rem;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0.1rem 0;

    & > .icon-item {
      width: 25%;
      /* 每个 item 占据一半宽度，减去间距 */
      @include flex($d: column);
      color: #333333;
      font-size: 0.14rem;
      position: relative;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      img {
        width: 0.3rem;
        height: 0.3rem;
        margin-bottom: 0.08rem;
      }

      span {
        line-height: 0.2rem;
        font-family: PingFangSC, PingFang SC;
      }

      .todo {
        display: inline-flex;
        content: "";
        position: absolute;
        width: 0.2rem;
        height: 0.16rem;
        background: #ef4034;
        border-radius: 0.08rem;
        border: 2px solid #ffffff;
        z-index: 10001;
        top: -0.08rem;
        right: 0.2rem;
        color: #fff;
        align-items: center;
        justify-content: center;
        font-size: 0.1rem;
        box-sizing: border-box;
      }
    }
  }
  .prop-wrap {
    height: 1rem;
  }
  .bottom-tip {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.11rem;
    color: #cccccc;
    line-height: 0.16rem;
  }
  .top24 {
    padding-top: 0.24rem;
    text-align: left;
  }
  .top16 {
    padding-top: 0.16rem;
  }

  /deep/ .van-notice-bar>i {
      color: #E12817 !important;
  }

  /deep/ .van-notice-bar__wrap {
      color: #333333;
  }
  .newsBar {
    margin-top: 0.16rem;
    // margin-bottom: 0.16rem;
    border-radius: 8px;
  }
  .flex-wrap {
    display: flex;
    flex-direction: row;
    .savePhoto {
      font-size: 0.16rem;
      margin-top: 0.16rem;
      color: #FFFFFF;
      background: #E12817;
      height: 0.42rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 24.5px;
      line-height: 0.22rem;
      flex: 1;
    }
    .redBg {
      background: #E12817 !important;
      color: #FFFFFF !important;
      margin-right: 0 !important;
    }
    .left {
      background: #FFFFFF;
      color: #E12817;
      margin-right: 0.17rem;
      border: 1px solid #E12817;
    }
  }
}
.assets-loading {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 99999;
  padding-top: 60%;
  background:rgba(0,0,0,0) ;
  .wrapperL{
      position: absolute;
      background-color: rgba(0,0,0,0.7);
      width:1.8rem;
      height: 1.2rem;
      border-radius: 0.04rem;
      left:50%;
      top:40%;
      transform: translate(-50%,-50%);
      display: flex;
      align-items: center;
      justify-content: center;
  }
}
</style>